import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.event-input-state { background-color: ${dt('eventInputState.background')}; }
`;
